import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from 'context'
import { NotificationRecipientsPage } from 'page-components/customer-complaint-log'

const CLAIM_PORTAL_COMPANY_ID = 34930

export const NotificationRecipientsScreen = () => {
    const { user } = useAuth()
    const companyId = Number(user?.CompanyId ?? user?.Companies?.[0]?.CompanyId)

    if (companyId !== CLAIM_PORTAL_COMPANY_ID) {
        return <Navigate to="/app/templates" replace />
    }

    return <NotificationRecipientsPage />
}
